import {
    cilList,
    cilHome,
    cilFlightTakeoff,
    cilChart,
    cilPeople,
    cilUser,
    cilChevronDoubleLeft,
    cilChevronDoubleRight,
    cilMenu,
    cilExitToApp,
    cilSearch,
    cibCircleci,
    cilPlaylistAdd,
    cilSpeech,
    cilBook,
    cilArrowThickFromLeft,
    cilSpeedometer,
    cilSettings,
    cilResizeWidth,
    cilUserPlus,
    cilFilter
} from '@coreui/icons';

export const iconSet = Object.assign({}, {
    cilPeople,
    cilUser,
    cilChevronDoubleLeft,
    cilChevronDoubleRight,
    cilMenu,
    cilExitToApp,
    cilList,
    cilHome,
    cilFlightTakeoff,
    cilChart,
    cilSearch,
    cibCircleci,
    cilPlaylistAdd,
    cilSpeech,
    cilBook,
    cilArrowThickFromLeft,
    cilSpeedometer,
    cilSettings,
    cilResizeWidth,
    cilUserPlus,
    cilFilter
});